import { combineReducers } from 'redux';

import authenticationReducer from './authentication/reducer';
import studyReducer from './study/reducer';
import headerReducer from './header/reducer';
import chatReducer from './chat/reducer';
import quizReducer from './quiz/reducer';
import gradesReducer from './grades/reducer';
import upcomingReducer from './upcoming/reducer';
import myTasksReducer from './mytasks/reducer';
import group_messagesSlices from './chat/group_messages.slices';
import userProfileSlice from './editProfile/userProfile.slices';
import direct_messagesSlices from './chat/direct_messages.slices';
import grades_slice from './grades/grades.slices';
import liveClassStudentsSlice from './liveClass/students.slices';
import active_status from './chat/active_status.slices';
import teacherCreateLiveClassSlice from './liveClass/teacherCreateLiveClass.slices';
import JoinLiveClassSlices from './liveClass/joinLiveClass.slices';
import TeacherGetLiveClassSlice from './liveClass/getLiveClassSlice.slice';
import TeacherGetGroupsSlice from './liveClass/teacherGetGroups.slice';
import mobile_screen_flowSlice from './mobile_screen_flow/mobile_screen_flow.slice';
import TeacherCreateGroupsSlice from './liveClass/teacherCreateGroups.slice';
import getMyLiveClassesStudent from './liveClass/studentLiveClassesList.slice';
import teacherRemoveGroupsSlice from './liveClass/teacherRemoveGroup.slice';
import specificChatSlice from './chat/specific_chat.slices';
import StudyDetailsSlice from './study/studyDetails.slice';
import StudySubjectsSlice from './study/studySubjects.slice';
import headerSlices from './header/header.slices';
import authReducer from './authentication/auth.slice';

const appReducer = combineReducers({
  auth: authReducer,
  study: studyReducer,
  header: headerReducer,
  chat: chatReducer,
  quiz: quizReducer,
  grades: gradesReducer,
  upcoming: upcomingReducer,
  mytasks: myTasksReducer,
  teacherGetGroupsSlice: TeacherGetGroupsSlice,
  group_messages: group_messagesSlices,
  grades_slice,
  userProfile: userProfileSlice,
  direct_messages: direct_messagesSlices,
  specificChat: specificChatSlice,
  active_status,
  getMyLiveClassesStudent,
  studyDetailsSlice: StudyDetailsSlice,
  studySubjectsSlice: StudySubjectsSlice,
  teacherCreateGroupsSlice: TeacherCreateGroupsSlice,
  liveClassStudentsSlice,
  teacherCreateLiveClassSlice,
  joinLiveClassSlice: JoinLiveClassSlices,
  getLiveClassSlice: TeacherGetLiveClassSlice,
  mobile_screen_flow: mobile_screen_flowSlice,
  teacherRemoveGroupsSlice,
  headerSlice: headerSlices,
  // DEPRICATED
  authentication: authenticationReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};
export default rootReducer;
